import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { FacadeService } from 'src/app/shared/services/facade.service';
import { AllCustomersState } from '../models/all-customers.models';
import * as selectors from '../selectors/all-customers.selectors';

@Injectable({ providedIn: 'root' })
export class AllCustomersFacadeService extends FacadeService {
  constructor(public override store: Store<AllCustomersState>) {
    super(store);
  }

  // OBSERVABLES
  mainPanelExpanded$ = this.storeSelect(selectors.getMainPanelExpanded);
  personalPanelExpanded$ = this.storeSelect(selectors.getPersonalPanelExpanded);
  otherPanelExpanded$ = this.storeSelect(selectors.getOtherPanelExpanded);
  registrationDateFrom$ = this.storeSelect(selectors.getRegistrationDateFrom);
  registrationDateUntil$ = this.storeSelect(selectors.getRegistrationDateUntil);
  registrationDateFromZ$ = this.storeSelect(selectors.getRegistrationDateFromZ);
  registrationDateUntilZ$ = this.storeSelect(selectors.getRegistrationDateUntilZ);
  registrationDateFromValidation$ = this.storeSelect(selectors.getRegistrationDateFromValidation);
  registrationDateUntilValidation$ = this.storeSelect(selectors.getRegistrationDateUntilValidation);
  registrationDateLTStartDate$ = this.storeSelect(selectors.getRegistrationDateLTStartDate);
  firstName$ = this.storeSelect(selectors.getFirstName);
  email$ = this.storeSelect(selectors.getEmail);
  lastName$ = this.storeSelect(selectors.getLastName);
  mobile$ = this.storeSelect(selectors.getMobile);
  memberTagOptions$ = this.storeSelect(selectors.getMemberTagOptions);
  memberTag$ = this.storeSelect(selectors.getMemberTag);
  qivosID$ = this.storeSelect(selectors.getQivosID);
  attributeTypeOptions$ = this.storeSelect(selectors.getAttributeTypeOptions);
  attributeType$ = this.storeSelect(selectors.getAttributeType);
  attributeNameOptions$ = this.storeSelect(selectors.getAttributeNameOptions);
  attributeName$ = this.storeSelect(selectors.getAttributeName);
  attributeValue$ = this.storeSelect(selectors.getAttributeValue);
  attributeBoolValue$ = this.storeSelect(selectors.getAttributeBoolValue);
  attributeDateFrom$ = this.storeSelect(selectors.getAttributeDateFrom);
  attributeDateUntil$ = this.storeSelect(selectors.getAttributeDateUntil);
  attributeDateFromZ$ = this.storeSelect(selectors.getAttributeDateFromZ);
  attributeDateUntilZ$ = this.storeSelect(selectors.getAttributeDateUntilZ);
  attributeDateFromValidation$ = this.storeSelect(selectors.getAttributeDateFromValidation);
  attributeDateUntilValidation$ = this.storeSelect(selectors.getAttributeDateUntilValidation);
  attributeDateLTStartDate$ = this.storeSelect(selectors.getAttributeDateLTStartDate);
  includeInactive$ = this.storeSelect(selectors.getIncludeInactive);
  disableSearch$ = this.storeSelect(selectors.getDisableSearch);
  attributeNameStringOrInteger$ = this.storeSelect(selectors.getAttributeNameStringOrInteger);
  attributeNameInteger$ = this.storeSelect(selectors.getAttributeNameInteger);
  attributeNameBoolean$ = this.storeSelect(selectors.getAttributeNameBoolean);
  attributeNameDate$ = this.storeSelect(selectors.getAttributeNameDate);
  editRole$ = this.storeSelect(selectors.getEditRole);
  personId$ = this.storeSelect(selectors.getPersonId);

  // OBSERVABLE'S VALUES
  get mainPanelExpanded() {
    return this.storeSnapshot(this.mainPanelExpanded$);
  }

  get personalPanelExpanded() {
    return this.storeSnapshot(this.personalPanelExpanded$);
  }

  get otherPanelExpanded() {
    return this.storeSnapshot(this.otherPanelExpanded$);
  }

  get registrationDateFrom() {
    return this.storeSnapshot(this.registrationDateFrom$);
  }

  get registrationDateUntil() {
    return this.storeSnapshot(this.registrationDateUntil$);
  }

  get registrationDateFromValidation() {
    return this.storeSnapshot(this.registrationDateFromValidation$);
  }

  get registrationDateUntilValidation() {
    return this.storeSnapshot(this.registrationDateUntilValidation$);
  }

  get firstName() {
    return this.storeSnapshot(this.firstName$);
  }

  get email() {
    return this.storeSnapshot(this.email$);
  }

  get lastName() {
    return this.storeSnapshot(this.lastName$);
  }

  get mobile() {
    return this.storeSnapshot(this.mobile$);
  }

  get memberTag() {
    return this.storeSnapshot(this.memberTag$);
  }

  get qivosID() {
    return this.storeSnapshot(this.qivosID$);
  }

  get attributeType() {
    return this.storeSnapshot(this.attributeType$);
  }

  get attributeName() {
    return this.storeSnapshot(this.attributeName$);
  }

  get attributeValue() {
    return this.storeSnapshot(this.attributeValue$);
  }

  get attributeBoolValue() {
    return this.storeSnapshot(this.attributeBoolValue$);
  }

  get attributeDateFrom() {
    return this.storeSnapshot(this.attributeDateFrom$);
  }

  get attributeDateUntil() {
    return this.storeSnapshot(this.attributeDateUntil$);
  }

  get attributeDateFromValidation() {
    return this.storeSnapshot(this.attributeDateFromValidation$);
  }

  get attributeDateUntilValidation() {
    return this.storeSnapshot(this.attributeDateUntilValidation$);
  }

  get includeInactive() {
    return this.storeSnapshot(this.includeInactive$);
  }

  get personId() {
    return this.storeSnapshot(this.personId$);
  }
}
